import React, { useEffect, useState, useRef } from "react";
import { api } from "@/lib/api";
import { QRCodeSVG } from "qrcode.react";
import { Printer, ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";
import { LogoIcon } from "@/components/Logo";

export default function QRPrint() {
  const [tables, setTables] = useState([]);
  const printRef = useRef(null);

  useEffect(() => {
    api.get("/tables").then(({ data }) => setTables(data));
  }, []);

  const baseUrl = window.location.origin;

  return (
    <div className="min-h-screen bg-white text-black print:bg-white">
      <div className="max-w-5xl mx-auto p-6 print:p-0">
        {/* Toolbar - hidden in print */}
        <div className="flex items-center justify-between mb-6 print:hidden">
          <Link to="/admin/tables" className="inline-flex items-center gap-2 text-sm text-gray-700 hover:text-black">
            <ArrowLeft size={15} /> Quay lại
          </Link>
          <button
            data-testid="print-qr-btn"
            onClick={() => window.print()}
            className="inline-flex items-center gap-2 px-4 py-2.5 rounded-md text-sm font-medium bg-black text-white hover:bg-gray-800"
          >
            <Printer size={15} /> In QR
          </button>
        </div>

        <h1 className="font-display font-bold text-2xl mb-1 print:text-3xl">In QR code các bàn bida</h1>
        <p className="text-gray-600 text-sm mb-6">Cắt và dán lên từng bàn. Khách quét QR sẽ thấy thông tin bàn, trận đang đấu và link đăng ký.</p>

        <div ref={printRef} className="grid grid-cols-2 sm:grid-cols-3 gap-4 print:grid-cols-2 print:gap-3">
          {tables.map((t) => {
            const url = `${baseUrl}/table/${t.number}`;
            return (
              <div key={t.id} className="border-2 border-black rounded-xl p-5 flex flex-col items-center text-center print:break-inside-avoid" data-testid={`qr-card-${t.number}`}>
                <div className="flex items-center gap-2 mb-2">
                  <LogoIcon size={32} />
                  <div className="font-display font-bold text-sm">ĐẤU TRƯỜNG BILLIARDS</div>
                </div>
                <div className="text-xs uppercase tracking-widest text-gray-500">Bàn số</div>
                <div className="font-display font-black text-6xl leading-none my-1">{t.number}</div>
                <div className="text-sm font-medium mb-3">{t.name || `Bàn ${t.number}`}</div>
                <div className="bg-white p-2 rounded border border-gray-200">
                  <QRCodeSVG value={url} size={160} level="M" includeMargin={false} />
                </div>
                <div className="mt-2 text-[10px] text-gray-500 break-all">{url}</div>
                <div className="mt-2 text-xs font-medium">Quét để xem trận & leo rank</div>
              </div>
            );
          })}
        </div>
      </div>

      <style>{`
        @media print {
          @page { margin: 1cm; }
          body { background: white !important; }
        }
      `}</style>
    </div>
  );
}
